module.exports = global["AuthenticationContext"] = require("-!.\\adal.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?AuthenticationContext!./~/modular-adal-angular/lib/adal.js-exposed
// module id = 9
// module chunks = 0